import { CustomFieldType, SupportedCustomFieldConnectors } from './custom-field-type'

export function validCustomFields(customFields: CustomFieldType[]): boolean {
  const invalidFields: CustomFieldType[] = []

  customFields.forEach(field => {
    // check that required fields have a value
    if (field.custom_field_name.trim() == '') {
      invalidFields.push(field)
      return
    }
    if (field.display_name.trim() == '') {
      invalidFields.push(field)
      return
    }
    // check for duplicate field values for the given connector's custom fields
    if (duplicateFieldName(field, customFields)) {
      invalidFields.push(field)
      return
    }
    if (duplicateDisplayName(field, customFields)) {
      invalidFields.push(field)
    }
  })

  return invalidFields.length == 0
}

function duplicateFieldName(field: CustomFieldType, allCustomFields: CustomFieldType[]): boolean {
  const fieldsWithGivenFieldName = allCustomFields.filter(
    f => f.custom_field_name.trim() == field.custom_field_name.trim(),
  )

  return fieldsWithGivenFieldName.length > 1
}

function duplicateDisplayName(field: CustomFieldType, allCustomFields: CustomFieldType[]): boolean {
  const fieldsWithGivenFieldDisplay = allCustomFields.filter(
    f => f.display_name.trim() == field.display_name.trim(),
  )

  return fieldsWithGivenFieldDisplay.length > 1
}

export interface CustomFieldValidation {
  isValid: boolean
  errorMsg: string
}

export function validateFieldName(
  connectorType: SupportedCustomFieldConnectors,
  field: CustomFieldType,
  allCustomFields: CustomFieldType[],
): CustomFieldValidation {
  const response: CustomFieldValidation = {
    isValid: true,
    errorMsg: '',
  }

  if (duplicateFieldName(field, allCustomFields)) {
    response.isValid = false
    response.errorMsg = '*Duplicate Remote Field IDs'
    return response
  }

  if (field.custom_field_name.length > 255) {
    response.isValid = false
    response.errorMsg = '*Remote Field ID must be less than 255 characters'
    return response
  }

  if (field.custom_field_name.trim() == '') {
    response.isValid = false
    response.errorMsg = '*Required'
    return response
  }

  switch (connectorType) {
    case 'branch':
      return validateBranchCustomField(field, response)
    case 'aem':
      return response
    default:
      return response
  }
}

export function validateDisplayName(
  field: CustomFieldType,
  allCustomFields: CustomFieldType[],
): CustomFieldValidation {
  const response: CustomFieldValidation = {
    isValid: true,
    errorMsg: '',
  }

  if (duplicateDisplayName(field, allCustomFields)) {
    response.isValid = false
    response.errorMsg = '*Duplicate Field Labels'
    return response
  }

  if (field.display_name.length > 255) {
    response.isValid = false
    response.errorMsg = '*Field Label must be less than 255 characters'
    return response
  }

  if (field.display_name.trim() == '') {
    response.isValid = false
    response.errorMsg = '*Required'
    return response
  }

  return response
}

// Connector Specific Custom Field Validators
// added functions should accept CustomFieldType and CustomFieldValidation as parameters and return CustomFieldValidation

function validateBranchCustomField(
  field: CustomFieldType,
  response: CustomFieldValidation,
): CustomFieldValidation {
  if (field.custom_field_name.includes('$')) {
    response.isValid = false
    response.errorMsg = '*The $ is not allowed for Branch custom fields'
  }
  return response
}
